// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewMenuModal_root__1Qv24","wrapper":"ViewMenuModal_wrapper__1SXs-","title":"ViewMenuModal_title__3LAJw"};